import { Route } from 'vue-router'
import API from '@/services/API'
import store from '@/store/store'

export default async function loginAndRedirect(to: Route) {
    if (!to.query.token) {
        throw new Error('Missing "token" for login')
    }

    await store.dispatch('user/setToken', { token: to.query.token })

    if (to.query.redirect) {
        await API.forceLogin(to.query.token as string)
        window.location.href = decodeURIComponent(to.query.redirect as string)
    }
}
